var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("td", [
    _vm.editOperations.remove
      ? _c(
          "button",
          {
            staticClass: "k-button k-grid-remove-command",
            on: { click: _vm.removeHandler },
          },
          [_vm._v("\n        Remove\n    ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }